import TabPanel, { Item } from 'devextreme-react/tab-panel';
import React from 'react';
import '../css/Portfolio.css';
import { useAppContext } from '../shared/AppContext';
import { GRANTSTATUS } from '../shared/Utils';
import PortfolioGrid from './PortfolioGrid';

interface IPortfilioProps {
}

export default function Portfolio({ }: IPortfilioProps) {
    const app = useAppContext();

    const showCombinedAwardsAndApplications = () => {

        if (app.UserIsExternalUser ||
            app.UserIsPI ||
            app.UserIsSO) {
            return true;
        }
        else {
            return false;
        }
    }

    if (!app.loginUser) {
        return (<div></div>);
    } else {
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12" style={{ marginTop: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                            {showCombinedAwardsAndApplications() ? (
                                <PortfolioGrid></PortfolioGrid>
                            ) :
                                (
                                    <TabPanel id='grantVisualizationsPanel'>
                                        <Item title='&nbsp;Awards&nbsp;'>
                                            <PortfolioGrid grantStatus={GRANTSTATUS.AWARDED}></PortfolioGrid>
                                        </Item>
                                        <Item title='&nbsp;Applications&nbsp;'>
                                            <PortfolioGrid grantStatus={GRANTSTATUS.APPLICATION}></PortfolioGrid> {/* this technically includes GRANTSTATUS.COUNCILREVIEW */}
                                        </Item>
                                    </TabPanel>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};